/* eslint-disable react/prop-types */
/**
 * InfoCard
 * Card Component that contain small information like number.
 */

import React from "react";
import { Skeleton } from "antd";
import PropTypes from "prop-types";
import Card from "./MocoCard";

const InfoCard = (props) => {
  const {
    content,
    options = {
      postfix: "",
      style: {
        color: "#F16B21",
      },
    },
    state,
  } = props;

  const defaultFunctions = {
    // This functions used for formatting data value
    format: (x) => {
      if (Number.isNaN(x)) return x;
      if (x < 9999) return x;
      if (x < 1000000) return `${Math.round(x / 1000)}K`;
      if (x < 10000000) return `${(x / 1000000).toFixed(2)}M`;
      if (x < 1000000000) return `${Math.round(x / 1000000)}M`;
      if (x < 1000000000000) return `${Math.round(x / 1000000000)}B`;
      return "1T+";
    },
  };

  const { functions = defaultFunctions } = props;

  const formatData = (params) => {
    // This function will check data props.
    if (typeof params === "object") {
      // If data props was object, so it will return Component object
      return (
        <div>
          <span
            className="text-bold"
            style={{
              fontSize: options.style.contentFontSize ?? 36,
            }}
          >
            {functions.format(params.value)}
          </span>
          &nbsp; &nbsp;
          <span className="text-header text-normal">
            {params.postfix ?? ""}
          </span>
        </div>
      );
    }
    // Else it will return the value of data
    return (
      <div className="text-header" style={{ color: options.style.textColor }}>
        {functions.format(params.value)}
      </div>
    );
  };

  return (
    <Card {...content} className="InfoCard" style={{ ...options.style }}>
      <Skeleton loading={state.data === undefined}>
        {state.data === undefined ? "0" : formatData(state.data)}
      </Skeleton>
    </Card>
  );
};

// Declare props data type
InfoCard.propTypes = {
  content: PropTypes.object,
  options: PropTypes.shape({
    style: PropTypes.object,
  }),
  state: PropTypes.shape({
    data: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
      PropTypes.array,
      PropTypes.number,
    ]),
  }),
  functions: PropTypes.object,
};

export default InfoCard;
